import { fromJS } from 'immutable';

export default {
    setSDM17DECs: (state, products) => {
        return state.setIn(['list'], fromJS(products)).set('initialized', true);
    },
    updateSDM17DECs: (state, products) => {
        return state.mergeIn(['list'], fromJS(products));
    },
    setSDM17DECDetails: (state, productId, product, lines) => {
        state = state.setIn(['list', productId], fromJS(product));
        return state.mergeIn(['list', productId, 'lines'], fromJS(lines));
    },
    updateSDM17DECStatus: (state, productId, status) => {
        return state.setIn(['list', productId, 'state'], status);
    },
    switchSDM17DECMaster: (state, productId, masterId) => {
        return state.setIn(['list', productId, 'userMasterId'], masterId);
    },
    dissociateUserFromSDM17DEC: (state, productId, userId) => {
        if (state.getIn(['list', productId, 'userMasterId']) === userId) {
            state = state.deleteIn(['list', productId, 'userMasterId']);
        }
        return state.deleteIn(['list', productId, 'usersList', state.getIn(['list', productId, 'usersList']).findIndex(i => i === userId)]);
    },
    dissociateUserFromSDM17DECAndSwitchMaster: (state, productId, userId, masterId) => {
        state = state.setIn(['list', productId, 'userMasterId'], masterId);
        return state.deleteIn(['list', productId, 'usersList', state.getIn(['list', productId, 'usersList']).findIndex(i => i === userId)]);
    }
};



// WEBPACK FOOTER //
// ./environments/fhepool/data/SDM17DEC/core.js